module.exports = __webpack_public_path__ + "img/blueRightArrow.deb57b65.svg";